export default __webpack_public_path__ + "static/media/rhr-outline.5e858259.svg";